import { Component, computed, inject, input, type TemplateRef, viewChild } from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal, type NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";

import { AdaaHelper } from "../../../../core/utils";
import { Constants } from "../../../constants/constants";
import { Language } from "../../../constants/enums";
import { TableActionEvent } from "../../../models";
import { AppService } from "../../../services";
import { DataTableComponent } from "../../table/data-table/data-table";

@Component({
  selector: "adaa-scores-by-aggregation-type",
  imports: [TranslatePipe, DataTableComponent],
  templateUrl: "./scores-by-aggregation-type.html",
  styleUrl: "./scores-by-aggregation-type.scss",
})
export class ScoresByAggregationTypeComponent {
  private readonly _translateService = inject(TranslateService);
  private readonly _modalService = inject(NgbModal);
  private readonly _appService = inject(AppService);
  private readonly _router = inject(Router);

  propId = input.required<number>();
  periodId = input.required<number | undefined>();
  year = input.required<number | undefined>();
  periodType = input.required<"year" | "quarter">();
  propName = input<"aggregationType" | "trackId">("aggregationType");
  isProjectScore = input<boolean>(false);

  modal = viewChild.required<TemplateRef<unknown>>("content");

  paramString = computed(() => {
    const periodId =
      this.periodId() ??
      +AdaaHelper.getLocalStorage(Constants.localStorageKeys.currentPlan, { type: "prop", property: "id" });

    return this.periodType() === "year"
      ? `${this.propName()}=${this.propId()}&year=${this.year()}`
      : `${this.propName()}=${this.propId()}&periodId=${periodId}`;
  });

  title = computed(() => (this.isProjectScore() ? "national_projects.projects" : "kpi.kpis_list"));

  apiName = computed(() =>
    this.isProjectScore() ? "getProjectScoresByAggregationType" : "getKpiScoresByAggregationType"
  );

  tableConfig = computed(() => {
    return this.isProjectScore()
      ? Constants.MAIN_TABLE_LIST_CONF_KEY.HOMEPAGE_PROJECTS_PERF_AGG_CONF_LIST
      : Constants.MAIN_TABLE_LIST_CONF_KEY.PMO_HOMEPAGE_PERF_AGG_CONF_LIST;
  });

  modalRef: NgbModalRef;

  public open() {
    this.modalRef = this._modalService.open(this.modal(), {
      animation: true,
      scrollable: false,
      keyboard: false,
      ariaLabelledBy: this._translateService.instant("kpi.kpis_list"),
      size: "xl",
      centered: true,
      modalDialogClass: this._appService.language() === Language.Arabic ? "modal-rtl" : "modal-ltr",
    });
  }

  public actionClicked(event: TableActionEvent) {
    const url = Constants.ITEM_TYPE_ROUTES.find(
      (e) => e.itemTypeId === (this.isProjectScore() ? event.data.type : event.data.kpiType)
    );
    if (url) {
      this.modalRef.close();
      this._router.navigateByUrl(`${url.route}${event.data.id}`);
    }
  }
}
